<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            {{ !updating ? "Yangi kurs yaratish" : "Kursni tahrirlash" }}
          </h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ValidationObserver v-slot="{ handleSubmit }">
              <form
                @submit.prevent="handleSubmit(submitForm)"
                class="form form-horizontal"
              >
                <div class="form-body">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="isActive">Aktivlashtirish</label>
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <div class="vs-checkbox-con vs-checkbox-primary">
                              <input
                                :disabled="loading"
                                id="isActive"
                                type="checkbox"
                                v-model="course.isActive"
                              />
                              <span class="vs-checkbox">
                                <span class="vs-checkbox--check">
                                  <i class="vs-icon feather icon-check" />
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="isActive">Bepul kurs</label>
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <div class="vs-checkbox-con vs-checkbox-primary">
                              <input type="checkbox" v-model="course.isFree" />
                              <span class="vs-checkbox">
                                <span class="vs-checkbox--check">
                                  <i class="vs-icon feather icon-check" />
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--                    <div class="col-12" v-if="!$store.state &&!$store.state.currentUser.isTeacher">-->
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="teacher">Kurs muallifi</label>
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <multiselect
                              :disabled="loading"
                              :multiple="false"
                              :options="teachers"
                              :placeholder="'Kurs muallifini tanlang'"
                              id="teacher"
                              label="name"
                              track-by="id"
                              v-model="teacher"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="name"
                            >Kurs nomlanishi
                            <span class="text-danger">*</span></label
                          >
                        </div>
                        <div class="col-md-9">
                          <ValidationProvider
                            name="Kurs nomlanishi"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <div class="position-relative has-icon-left">
                              <input
                                :disabled="loading"
                                class="form-control"
                                id="name"
                                name="fname-icon"
                                placeholder="Kurs nomlanishi"
                                type="text"
                                v-model="course.name"
                              />
                            </div>
                            <span
                              class="text-danger"
                              v-if="errors.length > 0"
                              >{{ errors[0] }}</span
                            >
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="shortName">Qisqa nomlanishi</label>
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <input
                              :disabled="loading"
                              class="form-control"
                              id="shortName"
                              name="fname-icon"
                              placeholder="Qisqa nomlanishi"
                              type="text"
                              v-model="course.shortName"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="price"
                            >Narxi<span class="text-danger">*</span></label
                          >
                        </div>
                        <div class="col-md-9">
                          <ValidationProvider
                            name="narhni"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <div class="position-relative has-icon-left">
                              <input
                                :disabled="loading"
                                class="form-control"
                                id="price"
                                name="fname-icon"
                                placeholder="Narxi"
                                type="number"
                                v-model.number="course.price"
                              />
                            </div>
                            <span
                              class="text-danger"
                              v-if="errors.length > 0"
                              >{{ errors[0] }}</span
                            >
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label>Ma'lumotnoma</label>
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <textarea
                              id="content"
                              class="form-control"
                              placeholder="Ma'lumotnoma"
                              v-model="course.description"
                              :disabled="loading"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="category"
                            >Kurs yo'nalishi<span class="text-danger"
                              >*</span
                            ></label
                          >
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <ValidationProvider
                              name="Kurs kategoriyasi"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <multiselect
                                :disabled="loading"
                                :multiple="false"
                                :options="categories"
                                :placeholder="'Kurs kategoriyasi'"
                                id="category"
                                label="name"
                                track-by="id"
                                v-model="category"
                              />
                              <span
                                class="text-danger"
                                v-if="errors.length > 0"
                                >{{ errors[0] }}</span
                              >
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="level"
                            >Kurs darajasi<span class="text-danger"
                              >*</span
                            ></label
                          >
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <ValidationProvider
                              name="Kurs darajasi"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <multiselect
                                :disabled="loading"
                                :multiple="false"
                                :options="levels"
                                :placeholder="'Kurs darajasini tanlang'"
                                id="level"
                                label="name"
                                track-by="id"
                                v-model="level"
                              />
                              <span
                                class="text-danger"
                                v-if="errors.length > 0"
                                >{{ errors[0] }}</span
                              >
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="subject"
                            >Fan<span class="text-danger">*</span></label
                          >
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <ValidationProvider
                              name="fan"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <multiselect
                                :disabled="loading"
                                :multiple="false"
                                :options="subjects"
                                :placeholder="'Fanni tanlang'"
                                id="subject"
                                label="name"
                                track-by="id"
                                v-model="subject"
                              />
                              <span
                                class="text-danger"
                                v-if="errors.length > 0"
                                >{{ errors[0] }}</span
                              >
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="language"
                            >Til<span class="text-danger">*</span></label
                          >
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <ValidationProvider
                              name="kurs tili"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <multiselect
                                :disabled="loading"
                                :multiple="false"
                                :options="languages"
                                :placeholder="'Kurs tilini tanlang'"
                                id="language"
                                label="name"
                                track-by="id"
                                v-model="language"
                              />
                              <span
                                class="text-danger"
                                v-if="errors.length > 0"
                                >{{ errors[0] }}</span
                              >
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="durationHour"
                            >Kurs davomiyligi(soatlarda)</label
                          >
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <input
                              :disabled="loading"
                              class="form-control"
                              id="durationHour"
                              type="number"
                              v-model.number="course.durationHour"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="durationMinute"
                            >Kurs davomiyligi(daqiqalarda)</label
                          >
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <input
                              :disabled="loading"
                              class="form-control"
                              id="durationMinute"
                              type="number"
                              v-model.number="course.durationMinute"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label
                            >Chiqarilgan sana<span class="text-danger"
                              >*</span
                            ></label
                          >
                        </div>
                        <div class="col-md-9">
                          <ValidationProvider
                            name="chiqarilgan sana"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <div class="position-relative has-icon-left">
                              <datepicker
                                :disabled="loading"
                                placeholder="chiqarilgan sana..."
                                v-model="course.releasedDate"
                              />
                            </div>
                            <span
                              class="text-danger"
                              v-if="errors.length > 0"
                              >{{ errors[0] }}</span
                            >
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="upload-picture-small">Kichik rasm</label>
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <div class="vs-checkbox-con vs-checkbox-primary">
                              <div id="upload-picture-small">
                                <upload-image
                                  :browseText="''"
                                  :data-images="smallImages"
                                  :disabled="loading"
                                  :dragText="'Kichik rasm'"
                                  :multiple="false"
                                  :popup-text="'Kichik rasm'"
                                  :primaryText="'Kichik rasm'"
                                  @before-remove="beforeRemovePictureSmall"
                                  @edit-image="editPictureSmall"
                                  @upload-success="uploadPictureSmallSuccess"
                                  editUpload="productUpdateEditId"
                                  idUpload="filePictureSmall"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="upload-picture-large">Katta rasm</label>
                        </div>
                        <div class="col-md-9">
                          <div class="position-relative has-icon-left">
                            <div class="vs-checkbox-con vs-checkbox-primary">
                              <div id="upload-picture-large">
                                <upload-image
                                  :browseText="''"
                                  :data-images="largeImages"
                                  :disabled="loading"
                                  :dragText="'Katta rasm'"
                                  :multiple="false"
                                  :popup-text="'Katta rasm'"
                                  :primaryText="'Katta rasm'"
                                  @before-remove="beforeRemovePictureLarge"
                                  @edit-image="editPictureLarge"
                                  @upload-success="uploadPictureLargeSuccess"
                                  editUpload="productUpdateEditId"
                                  idUpload="filePictureLarge"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <button
                            :disabled="loading"
                            class="btn btn-info waves-effect waves-light"
                            type="submit"
                            v-if="successMessage === ''"
                          >
                            <span
                              aria-hidden="true"
                              class="spinner-border spinner-border-sm"
                              role="status"
                              v-if="loading"
                            />
                            {{ updating ? "Kiritish" : "Tahrirlash" }}
                          </button>
                          <button
                            class="btn btn-success mr-1"
                            disabled="disabled"
                            type="button"
                            v-else
                          >
                            <i class="feather icon-check" />
                            {{ successMessage }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <a class="d-none" href="#" ref="anchor" />
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";

import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { is, required } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "Kiriting {_field_}",
});
extend("is", {
  ...is,
  message: "Aktivlashtiring",
});

export default {
  name: "CourseForm",
  data() {
    return {
      updating: false,
      languages: [],
      subjects: [],
      levels: [],
      level: null,
      categories: [],
      category: null,
      subject: null,
      language: null,
      teacher: {},
      teachers: [],
      smallImages: [],
      largeImages: [],
      course: {},
      loading: false,
      successMessage: "",
      errorMessage: "",
    };
  },
  components: {
    Datepicker,
    Multiselect,
    ValidationObserver,
    ValidationProvider,
  },
  methods: {
    getLanguages() {
      this.$api.get("admin/List/LanguageList").then((res) => {
        if (!res.error) {
          this.languages = res.result;
          if (this.$route.params.id !== 0) {
            this.language = this.languages.find(
              (l) => l.id === this.course.languageId
            );
          }
        }
      });
    },
    getSubjects() {
      this.$api.get("admin/List/SubjectList").then((res) => {
        if (!res.error) {
          this.subjects = res.result;
          if (this.$route.params.id !== 0) {
            this.subject = this.subjects.find(
              (l) => l.id === this.course.subjectId
            );
          }
        }
      });
    },
    getLevels() {
      this.$api.get("admin/List/LevelList").then((res) => {
        if (!res.error) {
          this.levels = res.result;
          if (this.$route.params.id !== 0) {
            this.level = this.levels.find((l) => l.id === this.course.levelId);
          }
        }
      });
    },
    getCategories() {
      this.$api.get("admin/List/CategoryList").then((res) => {
        if (!res.error) {
          this.categories = res.result;
          if (this.$route.params.id !== 0) {
            console.log(this.categories);
            this.category = this.categories.find(
              (c) => c.id === this.course.categoryId
            );
          }
        }
      });
    },
    getTeachers() {
      this.$api.get("admin/List/TeacherList").then((res) => {
        if (!res.error && res.statusCode === 200) {
          this.teachers = res.result;
          if (this.$route.params.id !== 0) {
            this.teacher = this.teachers.find(
              (t) => t.id === this.course.authorId
            );
          }
        }
      });
    },
    submitForm() {
      this.loading = true;
      if (this.updating) {
        this.updateCourse();
      } else {
        this.storeCourse();
      }
    },
    storeCourse() {
      this.$api
        .post("admin/Course/insert", this.courseFormData())
        .then((res) => {
          if (!res.error) {
            this.succMessage("Сохранено");
          } else {
            this.errMessage(res.error);
          }
        })
        .catch((err) => {
          this.errMessage("Ошибка");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getCourse(id) {
      this.$api
        .get(`admin/Course/${id}`)
        .then((res) => {
          if (!res.error) {
            this.updating = true;
            this.course = this.createCourseObject(res.result);

            let pictureSmall = {
              path: `${this.baseURL}${res.result.pictureSmall}`,
              default: 1,
              highlight: 1,
              caption: "caption to display. receive", // Optional
            };
            let pictureLarge = {
              path: `${this.baseURL}${res.result.pictureLarge}`,
              default: 1,
              highlight: 1,
              caption: "caption to display. receive", // Optional
            };

            this.smallImages.push(pictureSmall);
            this.largeImages.push(pictureLarge);
          }
        })
        .then((res) => {
          this.getLevels();
          this.getSubjects();
          this.getLanguages();
          this.getTeachers();
          this.getCategories();
        });
    },
    updateCourse() {
      this.$api
        .put("admin/Course/update", this.courseFormData())
        .then((res) => {
          if (!res.error) {
            this.succMessage("Yangilandi");
          } else {
            this.errMessage(res.error);
          }
        })
        .catch((err) => {
          this.errMessage("Ошибка");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createCourseObject(course = null) {
      if (course)
        return {
          id: course.id,
          name: course.name,
          shortName: course.shortName,
          description: course.description,
          levelId: course.levelId,
          subjectId: course.subjectId,
          languageId: course.languageId,
          durationHour: course.durationHour,
          durationMinute: course.durationMinute,
          releasedDate: course.releasedDate,
          filePictureSmall: course.filePictureSmall,
          filePictureLarge: course.filePictureLarge,
          isActive: course.isActive,
          price: course.price,
          authorId: course.authorId,
          categoryId: course.categoryId,
        };
      else
        return {
          id: 0,
          name: "",
          shortName: "",
          description: "",
          levelId: 0,
          subjectId: 0,
          languageId: 0,
          durationHour: 0,
          durationMinute: 0,
          releasedDate: null,
          filePictureSmall: null,
          filePictureLarge: null,
          isActive: true,
          price: 0,
          authorId: 0,
          categoryId: 0,
        };
    },
    courseFormData() {
      let form = new FormData();
      this.course.releasedDate = this.$moment(this.course.releasedDate).format(
        "MM.DD.YYYY"
      );
      for (let prop in this.course) {
        form.append(prop, this.course[prop]);
      }
      return form;
    },
    // UPLOAD SMALL PICTURE STARTED
    uploadPictureSmallSuccess(formData, index, fileList) {
      this.course.filePictureSmall = formData.get("file");
    },
    beforeRemovePictureSmall(index, done, fileList) {
      if (this.course.filePictureSmall) {
        this.deleteStoredImage(this.course.filePictureSmall);
        this.course.imageFormData = null;
        this.course.filePictureSmall = null;
      }
      done();
    },
    editPictureSmall(formData, index, fileList) {
      this.smallImages = [];
      this.course.imageFormData = formData;
      this.course.filePictureSmall = null;
    },
    // UPLOAD SMALL PICTURE FINISHED

    // UPLOAD LARGE PICTURE STARTED
    uploadPictureLargeSuccess(formData, index, fileList) {
      this.course.filePictureLarge = formData.get("file");
    },
    beforeRemovePictureLarge(index, done, fileList) {
      if (this.course.filePictureLarge) {
        this.deleteStoredImage(this.course.filePictureLarge);
        this.course.imageFormData = null;
        this.course.filePictureLarge = null;
      }
      done();
    },
    editPictureLarge(formData, index, fileList) {
      this.largeImages = [];
      this.course.imageFormData = formData;
      this.course.filePictureLarge = null;
    },
    // UPLOAD LARGE PICTURE FINISHED

    async deleteStoredImage(imageName) {
      let params = {};
      params.photo = imageName;
      return this.$api
        .post("file-uploads/delete-image", params)
        .then((res) => {
          if (res) {
            return res;
          } else {
            return false;
          }
        })
        .catch((error) => {
          return false;
        })
        .finally((item) => {
          ///
        });
    },
    errMessage(errorMessage) {
      this.errorMessage = errorMessage;
      this.$refs.anchor.click();
      this.notificationMessage(errorMessage, "error");
      setTimeout(() => {
        this.errorMessage = "";
      }, 5000);
    },
    succMessage(successMessage) {
      this.successMessage = successMessage;
      setTimeout(() => {
        this.$router.push({ name: "courses" });
        this.notificationMessage(successMessage, "success");
      }, 1000);
    },
  },
  watch: {
    level() {
      this.course.levelId = this.level.id;
    },
    category() {
      if (this.category && this.category.id) {
        this.course.categoryId = this.category.id;
      }
    },
    subject() {
      this.course.subjectId = this.subject.id;
    },
    language() {
      this.course.languageId = this.language.id;
    },
    teacher() {
      this.course.authorId = this.teacher.id;
    },
  },
  created() {
    if (this.$route.params.id !== 0) {
      this.getCourse(this.$route.params.id);
    } else {
      this.getSubjects();
      this.getLanguages();
      this.getLevels();
      this.getTeachers();
      this.getCategories();
      this.course = this.createCourseObject();
    }
  },
  mounted() {
    const datePicker = $(".vdp-datepicker");
    datePicker.addClass("flex-1");
    const inp = $('[readonly="readonly"]');
    inp.addClass("form-control");
    inp.attr("placeholder", "День / Месяц / Год");
  },
};
</script>

<style scoped></style>
